import React from 'react';
import { IPlayerLevel } from 'utils/types';
import { HeartOfVegasLeaguesPlayerLevel } from './Leagues';
import { HeartOfVegasPlayerLevel } from '.';

export const mapPlayerLevelDesign: Partial<Record<string, any>> = {
  ['playerlevel']: HeartOfVegasLeaguesPlayerLevel,
};

export const HeartOfVegasMapPlayerLevel: React.FC<IPlayerLevel> = ({
  designId,
  assetUrl,
  text = [],
  endsIn,
  onTimerDoneHandler,
}) => {
  const PlayerLevelComponent = designId
    ? mapPlayerLevelDesign[designId!]
    : HeartOfVegasPlayerLevel;

  if (!PlayerLevelComponent) {
    console.error('designId is missing or not supported');
    return <></>;
  }

  if (!assetUrl) {
    console.log('assetUrl is missing');
    return <></>;
  }

  return (
    <PlayerLevelComponent
      assetUrl={assetUrl}
      text={text}
      endsIn={endsIn}
      onTimerDoneHandler={onTimerDoneHandler}
    />
  );
};
